import styled from 'styled-components';
import { ReportFormatNumber } from '../../../../func/Function';
import { useEffect, useState } from 'react';
import { userGradeType } from '../../../../utils/auth';
import { useReportContext } from '../../../../context/DetailContext';
import LimitTable from '../../../components/limit/DetailLimitTable';
interface DataProps {
  name: string;
  desc: string;
  value: string;
}

interface AcutioncostsProps {
  data: DataProps[];
}

const AuctionCosts = ({ data }: AcutioncostsProps) => {
  const { regionAccess, quotaAccess } = useReportContext();
  const [isOpen, setIsOpen] = useState(true);

  const group1: DataProps[] = [];
  const group2: DataProps[] = [];
  let currentGroup = group1;

  data.forEach((item) => {
    if (item.name.includes('경매신청비용 소계')) {
      currentGroup.push(item);
      currentGroup = group2;
    } else if (item.name.includes('예납금 소계')) {
      currentGroup.push(item);
    } else if (!item.name.includes('청구금액') && !item.name.includes('총계')) {
      currentGroup.push(item);
    }
  });

  return (
    <Container id="경매집행비용">
      <Title>경매집행비용</Title>
      {!quotaAccess || !regionAccess ? (
        <LimitTable title="경매집행비용은" />
      ) : (
        <>
          <ListItemColorBox>
            <ListItem>
              <span>청구금액</span>
              {ReportFormatNumber(
                Number(data.find((item) => item.name === '청구금액')?.value),
              )}
            </ListItem>
          </ListItemColorBox>

          <Content>
            <ContentHeader onClick={() => setIsOpen((prev) => !prev)}>
              경매집행비용 총계
              <HeaderContent>
                {ReportFormatNumber(
                  Number(
                    data.find((item) => item.name === '경매집행비용 총계')
                      ?.value,
                  ),
                )}
                <img
                  src="/assets/images/arrow/arrow-up-black.svg"
                  alt=""
                  style={{
                    transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                  }}
                />
              </HeaderContent>
            </ContentHeader>
            {isOpen && (
              <ContentInner>
                <Section>
                  <Seperator />
                  <ListContent>
                    {group1.map((item) => (
                      <ListDataItem>
                        <ItemLabel $label={item.name}>{item.name}</ItemLabel>
                        <ItemContent $label={item.name}>
                          <div>{ReportFormatNumber(item.value)}</div>
                          <span>{item.desc}</span>
                        </ItemContent>
                      </ListDataItem>
                    ))}
                  </ListContent>
                </Section>
                <Section>
                  <Seperator />
                  <ListContent>
                    {group2.map((item) => (
                      <ListDataItem>
                        <ItemLabel $label={item.name}>{item.name}</ItemLabel>
                        <ItemContent $label={item.name}>
                          <div>{ReportFormatNumber(item.value)}</div>
                          <span>{item.desc}</span>
                        </ItemContent>
                      </ListDataItem>
                    ))}
                  </ListContent>
                </Section>
              </ContentInner>
            )}
          </Content>
        </>
      )}
    </Container>
  );
};

export default AuctionCosts;

interface WidthProps {
  width: string;
  name?: string;
}

interface TableRowProps {
  name: string;
}

const TableRowWrapper = styled.tr<TableRowProps>`
  border-bottom: 1px solid #e1e2e4;
  background-color: ${(props) => {
    if (props.name === '경매신청비용 소계' || props.name === '예납금 소계') {
      return '#E6F3FF'; // name이 '1'일 경우 배경색 빨간색
    } else if (props.name === '경매집행비용 총계') {
      return '#D3D3D3'; // name이 '2'일 경우 배경색 파란색
    }
    return 'none'; // 그 외의 경우 배경색 없음
  }};

  /* tr의 하위 td, th에 font-weight,color 적용 */
  td,
  th {
    color: ${(props) => {
      if (props.name === '경매신청비용 소계' || props.name === '예납금 소계') {
        return '#008AFF';
      }
      return '#171e26'; // 그 외의 경우 배경색 없음
    }};
    font-weight: ${(props) =>
      props.name === '경매집행비용 총계' ? '700' : '500'};
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #fff;
  padding: 24px 16px;
`;

const Title = styled.div`
  width: 100%;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 31.9px */
  letter-spacing: -0.44px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-end;
`;

const ListItemColorBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 10px 16px;
  gap: 8px;
  background: #f7f8fc;
`;

const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  gap: 8px;

  span {
    font-size: 12px;
    color: #616161;
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;

  font-weight: 500;
  font-size: 13px;
  color: #616161;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: #222;

  & > img {
    transition: transform 0.3s ease;
  }
`;

const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Seperator = styled.div`
  width: 3px;
  background-color: #f3f5f7;
`;

const Section = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const ListContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ListDataItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
`;

const ItemLabel = styled.div<{ $label: string }>`
  font-weight: 500;
  font-size: 12px;
  color: ${({ $label }) => ($label.includes('소계') ? '#008AFF' : '#37383c9c')};
`;

const ItemContent = styled.div<{ $label: string }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 500;
  font-size: 12px;
  color: ${({ $label }) => ($label.includes('소계') ? '#008AFF' : '#616161')};
  align-items: flex-end;

  span {
    font-size: 11px;
    color: #37383c9c;
  }
`;

const TableHeadTh = styled.th<WidthProps>`
  width: ${(props) => props.width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  &:last-child {
    border-right: none;
  }
`;
const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-right: 1px solid #e8e9ea;
  padding: 6px 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #222222;
  &:last-child {
    border-right: none;
  }
`;

const SingleRowTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const TableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #222;
`;
const SingleRowTableHeadCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px;
  letter-spacing: -0.36px;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SingleRowTableBodyCell = styled.div<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  border-bottom: 1px solid #e8e9ea;
  padding: 6px 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #616161;
`;
